export default __webpack_public_path__ + "static/2024_dk_esg-b77a4c7a2bc12bb165c50a01a1953d25.jpg";